import SHPraise from './src/praise.vue';


/**
 * 点赞展示和操作主键
 */

/* istanbul ignore next */
SHPraise.install = function(Vue) {
  Vue.component('sh-praise', SHPraise);
};
export default SHPraise;


// WEBPACK FOOTER //
// ./src/components/base/view/interact/cmps/praise/index.js